module.exports = __webpack_public_path__ + "static/Johnson-a23c7fd8d60efbb52e3bb5b8ec145e07.png";